import styled from "styled-components";
import { margin } from "styled-system";

export const StyledTextWrapper = styled.div`
  padding: 72px 11% 43px 8%;
  display: flex !important;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${({ indicatorColor, theme }) =>
    indicatorColor === "greenWhite" ? "#233247" : "#a6b7d0"};

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    justify-content: flex-start;
    box-sizing: border-box;
    min-height: 260px;
    width: 50%;
    margin-top: 50px;
    padding-left: 0px;
    margin-left: 40px;
    padding-right: 20px;
    max-width: 284px;
    padding-top: 14%;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    margin-left: 107px;

    padding-top: 80px;
  }
`;

export const StyledImageWrapper = styled.div`
  display: flex;
  justify-content: center;

  & > .img-wrapper {
    background: url("./images/phone-mockup.png");

    background-size: 100% auto;
    background-repeat: no-repeat;
    width: ${({ width }) => (width ? width : "200px")};
  }

  & img {
    width: 100% !important;
    height: auto;
  }

  & .phone-header {
    position: absolute;
    background: url("./images/test01.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    z-index: 1;
    height: 5%;
    top: 0;
    margin: 6.6% 6.5% 0;
    left: 0;
    width: 86.6%;
    border-top-left-radius: 10%;
    border-top-right-radius: 10%;
    //background: red;
  }
  & .phone-content {
    position: relative;
    padding: 7%;
    border-radius: 20%;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
  }

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    justify-content: flex-end;

    & > .img-wrapper {
      ${margin};
      width: ${({ width }) => (width ? width : "284px")};
    }

    & img {
      width: 100% !important;
      height: auto;
    }
  }
`;

export const StyledIndicator = styled.div`
  width: 15px;
  height: 15px;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    width: 25px;
    height: 25px;
  }
`;

export const StyledIndicatorWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  bottom: 180px;
  left: 50%;
  transform: translateX(-50%);
  
  & > li:not(:last-child):before {
  content: "";
  width: 15px;
  height: 1px;
  background: ${({ indicatorColor, theme }) =>
    indicatorColor === "greenWhite" ? "#E3E3E3" : theme.colors.white};
  position: absolute;
  left: 22px;
  top: 50%;
  border-radius: 2px;
  transform: translateY(-50%);
}

& > li {
    position: relative;
    border: 1px solid #D5D5D5;
    width: 15px;
    height: 15px;
    box-sizing: border-box;
    border-radius: 50%;
    margin: 0 15px;
    }
    
    & >.slick-active {
    background: ${({ indicatorColor, theme }) => theme.colors[indicatorColor]};
    border-color: ${({ indicatorColor, theme }) =>
      theme.colors[indicatorColor]};
    }
    
@media (min-width: ${({ theme }) => theme.queries.sm}) {
    display: flex;
    top: 12%;
    left: 0;
    flex-direction: column;
    
    & > li {
    margin: 25px 0;
    width: 25px;
    height: 25px;
    }
    
    & > li:not(:last-child):before {
    width: 1px;
    height: 42px;
    left: 50%;
    top: 29px;
    transform: translateX(-50%);
    }
    }
}
`;

export const StyledSliderWrapper = styled.div`
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > div:last-child {
    max-width: 500px;
  }

  & > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
    align-items: flex-start;
    padding-top: 50px;
    margin: 0 auto;

    & > div,
    & > div:last-child {
      width: 50%;
      max-width: inherit;
    }
  }
`;
